export function initialize(application) {
  application.inject("component", "appState", "service:app-state")
}

export default {
  name: "app-state",
  initialize,
}
